export default __webpack_public_path__ + "static/media/logo_spinner.0a8f615c.svg";